import type { AppState } from '@console/reducers';
import { createSelector } from 'reselect';

const getDistributionPartnerFromAppState = (state: AppState) =>
  state.distributionPartner;

export const getCreditLimitBalance = createSelector(
  [getDistributionPartnerFromAppState],
  (distributionPartner): number | null => distributionPartner.creditLimitBalance
);
